import { POST } from '../utilities/AxiosHelpers';

export function loginApi(username, password) {
  const formData = new FormData();
  formData.append('email', username);
  formData.append('password', password);
  return POST('admin/login', formData);
}

export function refreshTokenApi() {
  return POST('admin/refresh');
}

export function getProfile() {
  return POST('admin/profile');
}

export function updateProfile(data) {
  return POST('admin/updateProfile', data);
}

export function logoutApi() {
  return POST('admin/logout');
}

export const requestOtpApi = (data) => {
  return POST('admin/otp/send', data);
};

export const verifyOtpApi = (data) => {
  return POST('admin/otp/verify', data);
};

export const resetPasswordApi = (data) => {
  return POST('admin/forgot/change_password', data);
};

export const updatePasswordApi = (data) => {
  return POST('admin/update_password', data);
};

export const registerApi = (data) => {
  return POST('admin/register', data);
};
